import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { masterActions } from "stores/master/masterActions";
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions";

const mapStateToProps = (state) => {
  return {
    portfolioAlert: state.jarvisPrime.primeDashboard.portfolioAlert,
    portfolioPendingTransaction:
      state.jarvisPrime.primeDashboard.portfolioPendingTransaction,
    portfolioPendingTransactionLoading:
      state.jarvisPrime.primeDashboard.loading.portfolioPendingTransaction,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // Get API
      getPortfolioAlertAction: jarvisPrimeDashboardActions.getPortfolioAlert,
      getPortfolioPendingTransactionAction:
        jarvisPrimeDashboardActions.getPortfolioPendingTransaction,
      pendingCallAction: masterActions.getPendingCall,
      // Dashboard Refresh
      dashboardRefreshAction: jarvisPrimeDashboardActions.dashboardRefresh,

      // Set Toast Message
      setToastAction: commonActions.setToast,
    },
    dispatch
  );

const RMSRebalanceAlertStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default RMSRebalanceAlertStore;
